import { render } from "./BFormDatepicker.vue?vue&type=template&id=7057d10f"
import script from "./BFormDatepicker.vue?vue&type=script&lang=js"
export * from "./BFormDatepicker.vue?vue&type=script&lang=js"

import "./BFormDatepicker.vue?vue&type=style&index=0&id=7057d10f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__